import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { createPluginState } from './plugin-factory';
import { pluginKey } from './plugin-key';
export var createPlugin = function createPlugin(dispatch) {
  return new SafePlugin({
    state: createPluginState(dispatch, {}),
    key: pluginKey
  });
};